var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarsGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04002 0.000334142C8.96216 0.00360094 8.88718 0.0306377 8.82515 0.077811C8.76313 0.124984 8.71704 0.190028 8.69309 0.264188L6.89687 5.83108L1.04906 5.81952C0.968404 5.81937 0.889775 5.84481 0.824478 5.89217C0.75918 5.93953 0.710578 6.00637 0.685655 6.0831C0.660732 6.15982 0.660772 6.24247 0.685771 6.31917C0.710769 6.39587 0.759438 6.46266 0.824782 6.50996L5.56325 9.93891L3.74386 15.5C3.7188 15.5767 3.71869 15.6594 3.74355 15.7361C3.7684 15.8128 3.81694 15.8797 3.88219 15.9271C3.94743 15.9745 4.02603 16 4.10668 16C4.18733 15.9999 4.26588 15.9743 4.33105 15.9267L9.05605 12.4785L13.783 15.9268C13.8482 15.9743 13.9267 15.9999 14.0074 16C14.088 16.0001 14.1666 15.9745 14.2319 15.9271C14.2971 15.8797 14.3456 15.8128 14.3705 15.7361C14.3953 15.6594 14.3952 15.5767 14.3702 15.5L12.5508 9.93891L17.2892 6.50996C17.3546 6.46266 17.4032 6.39587 17.4282 6.31917C17.4532 6.24247 17.4533 6.15982 17.4284 6.0831C17.4034 6.00637 17.3548 5.93953 17.2895 5.89217C17.2242 5.84481 17.1456 5.81937 17.065 5.81952L11.217 5.83108L9.41885 0.26406C9.3932 0.184735 9.34227 0.116001 9.27385 0.0683722C9.20544 0.0207431 9.1233 -0.00315383 9.04002 0.000334142Z",
    fill: "#bababa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsGrey);
export default __webpack_public_path__ + "static/media/stars-grey.e22c2ab1a9802e5ba29ef4b45c7ea5fb.svg";
export { ForwardRef as ReactComponent };